import ExcelSheet from "../SvgIcons/ExcelSheet";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";

import { formatCountryDate } from "../../Services/countryTime";
export default function EventWiseUsersExcelReport({ data = [] }) {
  const handleDownload = async () => {
    try {
      if (!data.length) {
        await Swal.fire({
          icon: "warning",
          title: "Notice",
          text: "Select at least one event user to download.",
        });
        return;
      }

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("EventRegistrations");

      // -------------------
      // Helper functions
      // -------------------
      const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const d = new Date(dateStr);
        if (isNaN(d)) return dateStr;
        return formatCountryDate(d).replace(/\//g, "-");
      };

      const formatTime = (timeStr) => {
        if (!timeStr) return "";
        const [hour, minute] = timeStr.split(":");
        const date = new Date();
        date.setHours(hour, minute);
        return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: true });
      };

      // -------------------
      // Set column widths
      // -------------------
      worksheet.columns = [
        { width: 7 },   // Sr.No
        { width: 28 },  // Name
        { width: 37 },  // Email
        { width: 14 },  // Mobile
        { width: 40 },  // Organization
        { width: 13 },  // Tally Number
        { width: 12 },  // Participants
        { width: 19 },  // Registration Date
        { width: 17 },  // Mode of Meeting
      ];

      // -------------------
      // Calculate last column for merging
      // -------------------
      const totalCols = worksheet.columns.length;
      const lastColLetter = worksheet.getColumn(totalCols).letter;

      // -------------------
      // Main Title row (A1:lastCol)
      // -------------------
      worksheet.mergeCells(`A1:${lastColLetter}1`);
      const confirmationName = data[0]?.confirmation || "Unknown";
      const totalCount = data.length;
      const titleCell = worksheet.getCell("A1");
      titleCell.value = `Event Registrations by ${confirmationName} - (${totalCount})`;
      titleCell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
      titleCell.font = { bold: true, size: 14, color: { argb: "FFFFFF" } };
      titleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "38598e" } };
      worksheet.getRow(1).height = 30;

      // -------------------
      // Group data by Title + Event Date + Time
      // -------------------
      const grouped = data.reduce((acc, item) => {
        const groupKey = `${item.Title} - ${formatDate(item.event_date)} - (${formatTime(item.StartTime)} to ${formatTime(item.EndTime)})`;
        if (!acc[groupKey]) acc[groupKey] = [];
        acc[groupKey].push(item);
        return acc;
      }, {});

      // -------------------
      // Loop over each event group
      // -------------------
      let currentRow = 2;

      for (const [eventTitle, records] of Object.entries(grouped)) {
        // Event Title row
        worksheet.mergeCells(`A${currentRow}:${lastColLetter}${currentRow}`);
        const eventTitleCell = worksheet.getCell(`A${currentRow}`);
        eventTitleCell.value = eventTitle;
        eventTitleCell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
        eventTitleCell.font = { bold: true, size: 12, color: { argb: "000000" } };
        eventTitleCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "cce5ff" } };
        worksheet.getRow(currentRow).height = 25;
        currentRow++;

        // Headers
        const headers = [
          "Sr.No.",
          "Name",
          "Email",
          "Mobile No.",
          "Organization",
          "Tally Number",
          "Participants",
          "Registration Date",
          "Mode of Meeting",
        ];
        const headerRow = worksheet.addRow(headers);
        worksheet.getRow(headerRow.number).height = 25;

        headerRow.eachCell((cell) => {
          cell.font = { bold: true, color: { argb: "000000" } };
          cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
          cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "e5ebf5" } };
        });

        const leftAlignHeaders = ["Name", "Email", "Organization"];

        headerRow.eachCell((cell) => {
        const headerValue = cell.value;
        if (leftAlignHeaders.includes(headerValue)) {
          cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
        } else {
          cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
        }
        cell.font = { bold: true, color: { argb: "000000" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "e5ebf5" } };
      });

        // Data Rows
        records.forEach((customer, index) => {
          const row = worksheet.addRow([
            index + 1,
            customer.name,
            customer.email,
            customer.mobile,
            customer.organization,
            customer.tallynumber,
            customer.NoOfParticipants,
            formatDate(customer.registration_date),
            customer.ModeOfMeeting,
          ]);

          row.height = 20;

          row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
            if ([1, 4, 6, 7, 8, 9].includes(colNumber)) {
              cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
            } else {
              cell.alignment = { horizontal: "left", vertical: "middle", wrapText: true };
            }
          });
        });

        currentRow = worksheet.lastRow.number + 2;
      }

      // -------------------
      // Apply borders
      // -------------------
      const lastRow = worksheet.rowCount;
      for (let row = 1; row <= lastRow; row++) {
        for (let col = 1; col <= totalCols; col++) {
          const cell = worksheet.getCell(row, col);
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
        }
      }

      // -------------------
      // Export Excel
      // -------------------
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      saveAs(blob, "Event_Registrations.xlsx");

    } catch (error) {
      console.error("Error while downloading Excel:", error);
    }
  };

  return (
    <button type="button" className="btn btn-purpal addbutton" onClick={handleDownload}>
      <ExcelSheet /> Excel
    </button>
  );
}
